module.exports = __webpack_public_path__ + "static/media/weisman1.d61ec863.jpg";